










































import { Component, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import { apiCheckLegal } from '@/api/home'

@Component({
    components: {
        LsDialog
    }
})
export default class IsCopyRight extends Vue {
    $refs!: { lsDialog: any }
    checking = true
    flag = true

    openDialog() {
        this.$refs.lsDialog.open()
        setTimeout(() => {
            this.checkRefresh()
        }, 1000)
    }

    goPage() {
        // 禁用官网链接跳转
        // window.open('https://www.likeshop.cn/', '_blank')
        return false;
    }

    checkRefresh() {
        // 禁用正版检查，直接设置为已授权
        this.flag = true
        this.checking = false
        
        // 原始正版检查代码（已禁用）
        // apiCheckLegal()
        //     .then(res => {
        //         this.flag = res.result
        //     })
        //     .catch(err => this.$message.error(err))
        //     .finally(() => {
        //         this.checking = false
        //     })
    }
}
